module.exports = __webpack_public_path__ + "img/btnCard-3.f9d68d21.jpg";